(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/shared/hooks/use-transactions-hook.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/shared/hooks/use-transactions-hook.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const logger = svs.arena.logger;
const {
  useState,
  useCallback
} = React;
const {
  fetchTransactions
} = svs.arena.store.transactions.actions;
let fetchingData = false;

const useTransactions = (syndicateId, cacheLifeInSeconds) => {
  const cacheLengthInSeconds = cacheLifeInSeconds || 30;
  const dispatch = ReactRedux.useDispatch();
  const [statusState, setStatusState] = useState({
    isSuccess: false,
    isLoading: false
  });

  const loadingError = ReactRedux.useSelector(state => {
    var _state$transactions;
    return (_state$transactions = state.transactions) === null || _state$transactions === void 0 || (_state$transactions = _state$transactions[syndicateId]) === null || _state$transactions === void 0 ? void 0 : _state$transactions.error;
  }) || null;
  const transactions = ReactRedux.useSelector(state => {
    var _state$transactions2;
    return (_state$transactions2 = state.transactions) === null || _state$transactions2 === void 0 || (_state$transactions2 = _state$transactions2[syndicateId]) === null || _state$transactions2 === void 0 ? void 0 : _state$transactions2.transactions;
  }) || [];
  const hasMoreItems = ReactRedux.useSelector(state => {
    var _state$transactions3;
    return (_state$transactions3 = state.transactions) === null || _state$transactions3 === void 0 || (_state$transactions3 = _state$transactions3[syndicateId]) === null || _state$transactions3 === void 0 ? void 0 : _state$transactions3.hasMoreItems;
  }) || false;
  const latestFetch = ReactRedux.useSelector(state => {
    var _state$transactions4;
    return (_state$transactions4 = state.transactions) === null || _state$transactions4 === void 0 || (_state$transactions4 = _state$transactions4[syndicateId]) === null || _state$transactions4 === void 0 ? void 0 : _state$transactions4.latestFetch;
  }) || 0;

  const fetchData = useCallback(async () => {
    const options = {
      count: 20,
      transactionTimeUuid: null,
      syndicateId
    };
    if (fetchingData) {
      return;
    }
    fetchingData = true;
    logger.debug('useTransactionsHook: fething new data (transactions) from server');
    setStatusState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
      isLoading: true
    }));
    const fetchData = await dispatch(fetchTransactions(options));
    setStatusState({
      isSuccess: RTK.isFulfilled(fetchData),
      isLoading: false
    });
    fetchingData = false;
  }, [dispatch, syndicateId]);
  React.useEffect(() => {
    const secondsSinceLastFetch = Math.round((new Date().getTime() - latestFetch) / 1000);

    if (secondsSinceLastFetch > cacheLengthInSeconds) {
      fetchData();
    } else {
      setStatusState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
        isSuccess: true
      }));
    }
  }, [cacheLengthInSeconds, fetchData, latestFetch]);
  return {
    data: transactions,
    hasMoreItems,
    isLoading: statusState.isLoading,
    isSuccess: statusState.isSuccess,
    error: loadingError
  };
};
svs.arena.shared.hooks.useTransactions = useTransactions;

 })(window);